var packageName = "@atlassian/browser-storage-controls";
var packageVersion = "2.3.2";
export { packageName, packageVersion };